<template>
  <modal :name="id" class="w-80" height="auto">
    <div class="card">
      <div class="card-header bg-primary text-white">
        Bestätigung der Änderung
      </div>
      <div class="card-body text-primary">
        <div class="form">
          <div class="form-group">
            <label for="inputPassword"
              >Bitte aktuelles Passwort eingeben zur Bestätigung.</label
            >
            <div class="form-row">
              <div class="col-md-9 pb-1">
                <input
                  type="password"
                  class="form-control"
                  id="inputPassword"
                  placeholder="Passwort"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-primary pt-1 float-right float-md-left"
                  @click="$modal.hide(`modal-password-form`)"
                  type="submit"
                >
                  Bestätigen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: String
    }
  }
};
</script>
